<template>
    <el-container class="layout-wrapper">


        <el-container class="layout-container">
          <!-- 头部 START -->
          <el-header class="layout-header" >
            <div class="layout-header-menu">
              <!-- logo -->
              <!-- <div class="layout-header-logo">
                  <img class="logo" :src="logoUrl" alt />
              </div> -->
               <!-- logo -->
                <div class="header-inner">
                  <!-- 头部菜单 START -->
                      <el-tabs v-model="activeName" @tab-click="selectTopMenu">
                        <el-tab-pane v-for="(item,index) in menus" :key='index' :index='String(index)' :label="item.name" :name="String(index)"></el-tab-pane>
                      </el-tabs>

                    <!-- 头部菜单 END -->


                    <!-- 退出按钮 -->
                    <nav class="nav nav-right" style="margin:0 30px 0 56px;">
                        <!-- 用户基础操作 -->
                        <div class="nav-item" @click="onLogout"> <img style="width: 18px;height: 18px;margin-right: 5px;" src="../images/index/logout.png" />退出登录</div>
                    </nav>




                </div>

              </div>


             <!--  登录用户 -->
              <div class="header-info" >
                <div class="header-info-left" >
                  <div  class="personal-qrcode" > <i class="el-icon-menu"></i> </div>
                  <div class="header-info-name" >
                    您好，{{personalInfo.username?personalInfo.username:username}}！欢迎使用智慧人力零工系统后台管理系统！
                  </div>
                </div>
                <div class="header-info-right" >
                  {{currentDate}}
                </div>

              </div>


            </el-header>
            <!-- 头部 END -->

            <el-container class="layout-main-container">
              <!-- 侧边栏 START -->
              <!-- 当是首页菜单是，侧边栏特殊处理 -->
              <el-aside v-show="$route.path=='/home'" class="layout-aside">
                <div class="aside-personal-info" >
             <!--     <el-image class="personal-headerimg"
                    :src="personalInfo.avatars"
                    fit="fill"></el-image> -->
                        <el-image class="personal-headerimg"
                    :src="personalInfo.avatars"
                    fit="fill">
                          <div slot="error" class="image-slot" style="color: #000000;line-height: 120px;">
                            暂无头像
                          </div>
                        </el-image>
                    <div>{{personalInfo.username?personalInfo.username:username}}</div>
                    <div class="personal-opt-btn position" >{{personalInfo.role_name}}</div>

                    <div v-if="personalInfo.utypeid" class="personal-opt-btn updBtn"  >个人信息</div>
                    <div>上次登录时间：{{lastLoginTime}}</div>
                </div>

              </el-aside>

              <el-aside v-show="$route.path !='/home'"  :class="['layout-aside', {'aside-collapse': isCollapse}]" width="220px">

                  <el-menu class="aside-menu" unique-opened :default-openeds="secondMenu" :default-active="leftMenuIndex" router :collapse="isCollapse" menu-trigger="click" >

                    <div v-for="(item, index) in menuTree" :key='item.id' >
                      <template v-if="item.son.length>0">
                        <el-submenu :index='String(item.id)' >
                          <template slot="title">
                            <img v-if="item.img" class="icon" :src="item.img+'.png'" />
                            <span>{{item.name}}</span>
                          </template>
                          <el-menu-item-group>
                            <div v-for="(sitem,sindex) in item.son" :key="sitem.id">
                              <template v-if="sitem.stat!='' && sitem.stat!=null && sitem.stat!='null' && $route.path=='/'+sitem.stat">

                                <el-menu-item  :class="['li-item','is-active']" v-if="sitem.menu_type==1" @click="refreshPage(sitem.id,sitem.stat)" :index='String(sitem.id)' >
                                  <span slot="title" class="title">{{sitem.name}}</span>
                                </el-menu-item>
                              </template>
                              <template v-else>
                                <el-menu-item class="li-item non-active" style="font-size: 14px;" v-if="sitem.menu_type==1 && oldRoute=='/'+sitem.stat" @click="refreshPage(sitem.id,sitem.stat)"  :index='String(sitem.id)'>
                                  <img v-if="sitem.img" class="icon" :src="sitem.img+'.png'" />
                                  <span slot="title" class="title">{{sitem.name}}</span>
                                </el-menu-item>
                                <el-menu-item class="li-item" v-else-if="sitem.menu_type==1" @click="refreshPage(sitem.id,sitem.stat)"  :index='String(sitem.id)'>
                                  <img v-if="sitem.img" class="icon" :src="sitem.img+'.png'" />
                                  <span slot="title" class="title">{{sitem.name}}</span>
                                </el-menu-item>

                              </template>
                            </div>

                          </el-menu-item-group>
                        </el-submenu>
                      </template>
                      <template v-else>
                        <template v-if="item.stat!='' && item.stat!=null && item.stat!='null' && $route.path=='/'+item.stat">

                          <el-menu-item  :class="['li-item','is-active']" v-if="item.menu_type==1" @click="refreshPage(item.id,item.stat)" :index='String(item.id)' >
                            <img v-if="item.img" class="icon" :src="item.img+'_selected.png'" />
                          <!--  <i :class="['icon', item.icon]"></i> -->
                            <span slot="title" class="title">{{item.name}}</span>
                          <!--  <i v-show="!isCollapse" class="icon el-icon-arrow-right" style="float: right; font-size: 14px; margin-top: 15px;margin-right: -10px;"></i> -->
                          </el-menu-item>
                        </template>
                        <template v-else>
                          <el-menu-item class="li-item non-active" style="font-size: 14px;" v-if="item.menu_type==1 && oldRoute=='/'+item.stat" @click="refreshPage(item.id,item.stat)"  :index='String(item.id)'>
                            <img v-if="item.img" class="icon" :src="item.img+'.png'" />
                          <!--  <i :class="['icon', item.icon]"></i> -->
                            <span slot="title" class="title">{{item.name}}</span>
                          <!--  <i v-show="!isCollapse" class="icon el-icon-arrow-right" style="float: right; font-size: 14px; margin-top: 15px;margin-right: -10px;"></i> -->
                          </el-menu-item>
                          <el-menu-item class="li-item" v-else-if="item.menu_type==1" @click="refreshPage(item.id,item.stat)"  :index='String(item.id)'>
                            <img v-if="item.img" class="icon" :src="item.img+'.png'" />
                           <!-- <i :class="['icon', item.icon]"></i> -->
                            <span slot="title" class="title">{{item.name}}</span>
                          <!--  <i v-show="!isCollapse" class="icon el-icon-arrow-right" style="float: right; font-size: 14px; margin-top: 15px;margin-right: -10px;"></i> -->
                          </el-menu-item>

                        </template>

                      </template>


                    </div>

                  </el-menu>
              </el-aside>
              <!-- 侧边栏 END -->


              <!-- 主要内容 START -->
              <el-main class="layout-content">

                <!-- 面包屑路径 START -->
                <el-breadcrumb v-show="$route.path !='/home'" class="header-breadcrumb" separator=">">
                <div style="float:left;display: flex;">
                  <img style="margin-top:10px;margin-right: 8px;margin-left: 15px; width:16px;height: 18px;" src="../../static/img/location.png" />
                  <div>当前位置：</div>
                </div>

                    <el-breadcrumb-item class="item" v-for="item in breadcrumb" :key="item">
                        <span v-text="item"></span>
                    </el-breadcrumb-item>

                </el-breadcrumb>
                <!-- 面包屑路径 END -->
                  <section class="fluid-content" v-if="isRefresh">
                      <keep-alive :include="keepAlive">
                          <router-view></router-view>
                      </keep-alive>
                  </section>
              </el-main>
            </el-container>

        </el-container>
        <!-- 主要内容 END -->


    </el-container>
</template>

<script>
//import { getUser } from "@/utils/auth";
//import { roleRoutes } from "@/router/index";
import $ from 'jquery'
export default {
    data() {
        return {
            activeIndex: '0',
            activeName:'',//被激活的1级菜单（头部菜单）
            secondMenu:[],//展开的2级菜单
            leftMenuIndex:'0',//被激活的3级菜单
            menus:this.$store.getters.getmenulist,
            isRefresh: true,
            pageLoading: null,
            username: "",
            enterpriseName:"",
            breadcrumb: [], // 面包屑路径
            menuTree: [], // 菜单
            screenWidth:
                document.documentElement.clientWidth ||
                document.body.clientWidth ||
                window.innerWidth, // 检测屏幕宽度
            showCollapseHandle: true,
            isCollapse: false, // 是否折叠
            // logoUrl: '../../static/img/logo_new.png',
            adminid:this.$store.state.adminid,
            roleid:this.$store.state.role_id,
            searchKey:"",
            isLogout:false,//是否离开了页面
            company_uid:'',
            oldRoute:"",
            personalInfo:{
              utypeid:this.$store.state.utypeid,//绑定的小程序账号id
              avatars:this.$store.state.avatars,//头像
              username: this.$store.state.miniUsername,
              role_name: this.$store.state.role_name
            },
            currentDate:"",//今天日期
            lastLoginTime:this.$store.state.lastLoginTime,//最后登录时间
            myHeaders:{},
        };
    },
    created() {
        window.addEventListener("resize", this.handleResize);
        this.username = this.$store.state.username;
        this.enterpriseName =  this.$store.state.enterpriseName;
       // this.initWebSocket()
        //this.getMsgList()
    },
    beforeMount() {

      if(this.$store.state.token_type==='' || this.$store.state.token_type===''){
         console.log("未store,要登录")
        this.Nodes.mustlogin();return false;
      }
        this.setMenuTree();
        /* 屏幕适应配置 */
        if (this.screenWidth <= 768) {
            // this.showCollapseHandle = false;
            this.isCollapse = true;
            sessionStorage.setItem(
                "AsideCollapseKey",
                JSON.stringify(this.isCollapse)
            );
        } else {
            let collapseKey = sessionStorage.getItem("AsideCollapseKey");
            // this.showCollapseHandle = true;
            this.isCollapse = collapseKey ? JSON.parse(collapseKey) : false;
        }
    },
    mounted() {
      let token = this.$store.state.token;
      let token_type = this.$store.state.token_type;
      this.myHeaders = {
        authorization: token_type + " " + token,
      };
      if(token) {
        this.queryMenu()
      }
      this.getCurrentDate()

    },
    activated() {
        this.username = this.$store.state.username;
        this.getRoutePath(this.$route);
    },

    watch: {
        $route(val, oldVal) {

            // 检测路由变化
            if(oldVal.path) {
              this.oldRoute = oldVal.path
            }
            this.getRoutePath(val);
        },
        isCollapse(val) {
            // if (val) {
            //     this.logoUrl = require('../../static/img/logo2.png')
            // } else {
            //     this.logoUrl = require('../../static/img/logo_new.png')
            // }
        },

    },
    computed: {
        keepAlive() {
            return this.$store.getters.keepAlive;
        }
    },
    methods: {
      // 获取当前获取日期
      getCurrentDate() {
        var date = new Date;
        var year = date.getFullYear();//获取低昂去年份
        var month = date.getMonth() + 1;//获取当前月份
        var dates = date.getDate();//获取当前是几日
        var day = date.getDay(); //获取当前是星期几
        var arr = ['星期日','星期一','星期二','星期三','星期四','星期五','星期六'];
        this.currentDate = '今天是' + year + '年' + month + '月' + dates + '日 ' + arr[day]
      },
        queryMenu(){
          this.gets('index/newMenuList').then(res=>{
            if(res.data.code == 1){
              let data = res.data.data
              this.menus = data;
              this.menuTree = data[this.activeIndex].son
              this.$store.commit('setmenulist',data)
            }
          })
        },

        handleResize() {
            // 检测屏幕宽度
            this.screenWidth =
                document.documentElement.clientWidth ||
                document.body.clientWidth ||
                window.innerWidth;

            if (this.screenWidth <= 1024) {
                this.isCollapse = true;
            } else {
                this.isCollapse = false;
            }
            sessionStorage.setItem(
                "AsideCollapseKey",
                JSON.stringify(this.isCollapse)
            );
        },

        setMenuTree() {
            this.menuTree = this.menus[this.activeIndex].son;//左侧菜单
            if(this.menuTree[0].son.length>0) {
              this.$router.push({path:this.menuTree[0].stat})
              this.leftMenuIndex = String(this.menuTree[0].id);
              this.secondMenu = [String(this.menuTree[0].id)];
            }else{
              this.$router.push({path:this.menuTree[0].stat})
              this.leftMenuIndex = String(this.menuTree[0].id);
              this.secondMenu = [];
            }

        },
        //选择头部菜单
        selectTopMenu(e) {
          this.activeIndex = e.name;
          this.menuTree = this.menus[this.activeIndex].son
          if(this.menuTree[0]){
            if(this.menuTree[0].son.length>0) {
              this.$router.push({path:this.menuTree[0].stat})
              this.leftMenuIndex = String(this.menuTree[0].id);
              this.secondMenu = [String(this.menuTree[0].id)];
            }else{
              this.$router.push({path:this.menuTree[0].stat})
              this.leftMenuIndex = String(this.menuTree[0].id);
              this.secondMenu = [];
            }
          }

        },

        handleCollapseAsdie() {
            // 切换侧边栏
            this.isCollapse = !this.isCollapse;
            sessionStorage.setItem(
                "AsideCollapseKey",
                JSON.stringify(this.isCollapse)
            );
        },
        refreshPage(menu_id,path) {
            // 刷新页面

            this.isRefresh = false;
            this.$nextTick(() => {
                this.isRefresh = true;
            });

            sessionStorage.setItem('current-menu-id', menu_id);
            this.leftMenuIndex = String(menu_id) ;
            this.$router.push({path:path})
        },

        getRoutePath(route) {
          let that = this;
            // 获取--面包屑路径
            if (route.meta && route.meta.pathName) {
                this.breadcrumb = route.meta.pathName;
            } else {
                this.breadcrumb = [route.meta.name || ""];
            }
            //检查路由所属的模块（头部菜单）
            let menus = this.menus;
            let croute = this.$route.path ;
            let isOk = false;
            that.secondMenu = [];

            for(let index=0;index<menus.length;index++) {
              let e = menus[index]
              if(e.son.length>0) {
                for(let i=0;i<e.son.length;i++) {
                  let se = e.son[i].son;

                  if(se && se.length>0) {

                    for(let j=0; j<se.length;j++) {
                      if( '/' + se[j].stat==croute) {
                        that.menuTree = e.son;
                        that.activeIndex = String(index) ;
                        that.activeName = String(index);
                        that.leftMenuIndex = String(se[j].id) ;
                        that.secondMenu = [String(se[j].id)];
                        that.secondMenu = [String(e.son[i].id)];
                        isOk = true;
                        break;
                      }
                    }

                  }else{
                    if( '/' + e.son[i].stat==croute) {

                      that.menuTree = e.son;
                      that.activeIndex = String(index) ;
                      that.activeName = String(index);
                      that.leftMenuIndex = String(e.son[i].id) ;
                      isOk = true;
                      break;
                    }
                  }


                }
              }
              if(isOk) {
                return;
              }
            }

        },
        onLogout() {
            // 退出系统

            this.$store.commit('settoken','')
            this.$store.commit('setmenulist','')
            this.$store.commit('setauthlist','')
            this.$store.commit('settoken_type','');
            this.$store.commit('settopmenu','');
            this.Nodes.mustlogin()
        },



    }
};
</script>
<style scoped>
.updatecontent{width: 20%;float: left;padding:8px;}
.updatetitle{text-align: center;font-size: 20px;padding:8px;}
.updateinfo{padding:8px;}
.personal-info-container{
  display: flex;
  justify-content: space-around;
  align-items: center;
  margin: 130px 0 140px;
}
.personal-info-container div{
  line-height: 1;
}
.personal-info-container .info-left{
  text-align: center;
}
.personal-info-container img{
  width: 126px;
  height: 126px;
  background: #FFFFFF;
  box-shadow: 0px 3px 10px 0px rgba(0, 0, 0, 0.2);
  border-radius: 50%;
  margin-bottom: 34px;
}
.personal-info-container .col-line{
  width: 1px;
  height: 120px;
  background: #E6E6E6;
  box-shadow: 1px 0px 0px 0px #FFFFFF;
}
.personal-info-container .info-right div{
  margin-bottom: 24px;
}

</style>



// WEBPACK FOOTER //
// src/view/index.vue